import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { nextTick, PropType, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AllCategoriesBlockWrapper',
  props: {
  contentId: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const showExpand = ref<boolean>(true);
const isCategoryOpen = ref<number>(0);
const expandedCategories = ref<Array<number>>([]);

const openCategory = (id: number) => {
  isCategoryOpen.value = id;
  nextTick(() => {
    const contentId = props.contentId[id];
    const contentEl = document.getElementById(contentId);
    if (contentEl && contentEl.scrollHeight > 450) {
      showExpand.value = true;
    } else {
      showExpand.value = false;
    }
  });
};

const onCategoryClick = (id: number) => {
  openCategory(id);
};

const expandCategory = (id: number) => {
  expandedCategories.value.push(id);
};

const collapseCategory = (id: number) => {
  expandedCategories.value = expandedCategories.value.filter((x) => x != id);
};

const onToggleExpandCategoryClick = (id: number) => {
  if (expandedCategories.value.includes(id)) {
    collapseCategory(id);
  } else {
    expandCategory(id);
  }
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    isCategoryOpen: isCategoryOpen.value,
    onCategoryClick: onCategoryClick,
    expandedCategories: expandedCategories.value,
    onToggleExpandCategoryClick: onToggleExpandCategoryClick,
    showExpand: showExpand.value
  })
}
}

})